import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenStorage {
    private tokenKey = 'auth_token';

    signOut(): void {
        localStorage.removeItem(this.tokenKey);
    }

    saveToken(token: string, forUser: string): void {
        localStorage.setItem(this.tokenKey, JSON.stringify({id: forUser, token: token}));
    }

    getTokenData(): { id: number, token: string } | null {
        const data = localStorage.getItem(this.tokenKey);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    getTokenForHeader(): string | null {
        const data = localStorage.getItem(this.tokenKey);
        if (data) {
            return JSON.parse(data).token;
        }
        return null;
    }
}
